import { render } from "./CategoryAdminsTable.vue?vue&type=template&id=5346f602"
import script from "./CategoryAdminsTable.vue?vue&type=script&lang=js"
export * from "./CategoryAdminsTable.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/nahodka.xpage.dev/htdocs/public/local/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__